module.exports = __webpack_public_path__ + "img/icon_solution_text03.cc63f1f7.png";